<mat-accordion *ngIf="order && (isDownloadInvoiceEnabled$ | async) !== null && showInvoice">
  <div class="container-group">
    <mat-expansion-panel hideToggle>
      <mat-expansion-panel-header>
        <mat-panel-title class="summary-title">
          {{
            'myAccount.orderDetails.invoiceSummary.title'
              | cxTranslate : { num: filterInvoice(order?.consignments).length }
          }}
        </mat-panel-title>
        <mat-icon class="material-icons-sharp light material-icons mat-icon-no-color" role="img">expand_more</mat-icon>
      </mat-expansion-panel-header>
      <div class="summary-details">
        <ng-container *ngIf="filterInvoice(order?.consignments).length > 0">
          <button
            *ngIf="
              showDesktop && filterValidInvoice(order?.consignments).length > 0 && isDownloadInvoiceEnabled$ | async
            "
            class="tertiary-btn download-all-invoices"
            type="button"
            (click)="downloadAllInvoices(order.consignments)"
          >
            {{ 'myAccount.orderDetails.downloadAllInvoices.title' | cxTranslate }}
            <mat-icon class="light" svgIcon="exportfile"></mat-icon>
          </button>
          <ng-container *ngFor="let con of filterInvoice(order.consignments)">
            <div class="invoice-entry" *ngIf="con?.invoice && !features?.hidePayment">
              <div class="referenceNumber">
                {{ con?.invoice?.referenceNumber }}
              </div>
              <div class="paymentStatus">
                <b>{{ con?.invoice?.paymentStatusDisplay }}</b
                >{{
                  con?.invoice?.paymentStatus !== '' && con?.invoice?.paymentStatus !== 'PAID'
                    ? ('myAccount.orderDetails.invoiceSummary.dueOn'
                      | cxTranslate : { date: con?.invoice?.date | date : 'dd/MM/yyyy' })
                    : ''
                }}
              </div>
              <a
                *ngIf="con?.invoice?.downloadLink !== '' && isDownloadInvoiceEnabled$ | async"
                [href]="con?.invoice?.downloadLink"
                download=""
                rel="noopener noreffer"
                target="_blank"
                type="application/octet-stream"
                class="download-invoice"
              >
                <mat-icon class="light" svgIcon="exportfile"></mat-icon>
              </a>
            </div>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="filterInvoice(order?.consignments).length === 0 && isCustomTranslationsEnabled !== null">
          <div class="invoice-summary-empty">
            {{
              'myAccount.orderDetails.invoiceSummary.empty'
                | cxTranslate
                  : {
                      context: setCustomContext(
                        isCustomTranslationsEnabled,
                        activeCountry$ | async,
                        activeLanguage$ | async
                      )
                    }
            }}
          </div>
        </ng-container>
      </div>
    </mat-expansion-panel>
  </div>
</mat-accordion>
